// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__z8uGs","resendInfoText":"OnGoingPaymentBox_resendInfoText__3jt1c"};